import {ChangeDetectorRef, Component, forwardRef, OnInit, ViewChild} from "@angular/core";
import {DispatchItemsTableComponent} from "../dispatch-items-table/dispatch-items-table.component";
import {DispatchListItem} from "../../../shared/view-model/store-management/dispatch-list-item.type";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {DispatchList} from "../../../shared/view-model/store-management/dispatch-list.type";
import {appInjector} from "../../../index";
import {MedicineAuthFormComponent} from "../../withdrawal/medicine-auth-form/medicine-auth-form.component";

@Component({
  selector: 'vb-new-dispatch',
  templateUrl: './new-dispatch.component.html',
  styleUrls: ['./new-dispatch.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => NewDispatchComponent)}]
})
export class NewDispatchComponent extends AbstractVisbosControl<DispatchList, FormGroup> implements OnInit {

  @ViewChild(DispatchItemsTableComponent)
  dispatchItemsTblCmp: DispatchItemsTableComponent;

  hasItems: boolean = false;
  selectedDeliveryItems = [];

  dispatchItems: DispatchListItem[] = [];


  medicineAuthForm: FormGroup;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {

    super(fb, cd, sessionActions);

    this.actions = [
      {
        label: "Ware einlagern",
        icon: "fa-paper-plane",
        action: () => this.sendDispatch.apply(this),
        disabled: () => !this.canSend.apply(this)
      }
    ]

  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: DispatchList): FormGroup {
    return NewDispatchComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      source_administration_unit_id: [null, Validators.required],
      target_administration_unit_id: [null, Validators.required],
      dispatch_date: [null, Validators.required],
      packing_slip_number: [null],
      packer_name: [null],
      user_id: [null, Validators.required],
      dispatch_items: fb.array([], Validators.required)
    });
  }

  public setDefaultValues(item?: DispatchList): { [controlKey: string]: any } | any {

    let val = {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      source_administration_unit_id: this.setValue(item, 'source_administration_unit_id', this.activeAdminUnitCuid),
      target_administration_unit_id: this.setValue(item, 'target_administration_unit_id'),
      dispatch_date: this.setValue(item, 'dispatch_date', new Date().toISOString().slice(0, 10)),
      packing_slip_number: this.setValue(item, 'packing_slip_number'),
      packer_name: this.setValue(item, 'packer_name'),
      user_id: this.setValue(item, 'user.cuid', this.currentUser.cuid),
    };

    this.addDispatchItems(item, <FormArray>this.control.get('dispatch_items'));

    return val;

  }

  private canSend(): boolean {
    let authOk = !this.medicineAuthForm || (this.medicineAuthForm && this.medicineAuthForm.valid);
    return this.hasItems && authOk;
  }

  createMedicineAuthComponent() {
    this.medicineAuthForm = MedicineAuthFormComponent.initControl(this.fb);
    this.cd.detectChanges();
  }

  addDispatchItems(dispatchList: DispatchList, formArray: FormArray) {
    formArray.controls = [];
    let dispatchItems: DispatchListItem[] = dispatchList.dispatch_list_items;

    dispatchItems.forEach(item => {

      formArray.push(this.initDispatchItemControl(dispatchList, item));
      if (!this.medicineAuthForm && item.source_stocks && item.source_stocks.find(s => s.registration_required === true)) {
        this.createMedicineAuthComponent();
      }

    });

    this.dispatchItems = [...this.control.get('dispatch_items').value]

  }

  initDispatchItemControl(dispatchList?: DispatchList, dispatchItem?: DispatchListItem): FormGroup {

    return this.fb.group({
      cuid: [this.setValue(dispatchItem, 'cuid', AbstractVisbosControl.cuid())],
      article_number: [this.setValue(dispatchItem, 'article_number')],
      article_label: [this.setValue(dispatchItem, 'article_label'), Validators.required],
      packing_unit: [this.setValue(dispatchItem, 'packing_unit')],
      packing_content: [this.setValue(dispatchItem, 'packing_content'), Validators.required],
      amount: [this.setValue(dispatchItem, 'amount_in_pieces_open'), Validators.required],
      price: [this.setValue(dispatchItem, 'price')],
      product_packing_id: [this.setValue(dispatchItem, 'product_packing.cuid')],
      referenced_order_item_id: [this.setValue(dispatchItem, 'cuid')],
      stock_id: [null, Validators.required],
      product_batches_ids: this.fb.array([])
    });

  }

  sendDispatch() {
    let input = Object.assign({}, this.control.value);
    let medAuthData = this.medicineAuthForm ? this.medicineAuthForm.value : null;

    input.delivery_items = input.delivery_items.filter(item => this.selectedDeliveryItems.find(sel => sel === item.cuid));
    /*
        this.procurementService.createDelivery(this.order.cuid, input, medAuthData).toPromise()
          .then(res => {
            this.sessionActions.pushMessage("Lieferung erfolgreich angelegt und Waren eingelagert!", MessageType.SUCCESS, "Warenlieferung");
            this.loc.back();
          })
          .catch(err => {
            this.err.handleUserError(err, "Fehler beim Anlegen der Lieferung und Einlagern der Waren!")
          });

    */
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/new-dispatch/new-dispatch.component.ts